import styled, { keyframes } from "styled-components";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Empty from "../Empty";
import Table from "../components/Table";

const filterReports = (reports, userPerms) => {
  if (!reports) return [];

  if (userPerms?.account_type === 5)
    return reports.filter((report) => report.template_id !== 11);

  if (
    userPerms?.account_type !== 5 &&
    userPerms?.employee_employee_permission?.details?.length > 0
  ) {
    return reports.filter(
      (report) => report.template_id !== 4 && report.template_id !== 11
    );
  }

  return reports;
};

const List = ({ setDeleteId, setDeleteItem, pdfList }) => {
  const navigate = useNavigate();
  const { coreData, pdfReports, fetched } = useSelector(
    (state) => ({
      coreData: state.audit?.core_data,
      pdfReports: state.debrief_pdf_report,
      fetched: state.debrief_pdf_report.fetched,
    }),
    shallowEqual
  );

  // Check if we should show the Empty component
  const shouldShowEmpty = coreData?.categories && pdfReports?.templates && pdfList && pdfList.length === 0 && fetched;


  return (
    <Container>
      <Center>
        <Title>
          Report History
          <Button onClick={() => navigate("/leader/audit/reports/create")}>
            Create Report
          </Button>
        </Title>

        {!shouldShowEmpty ? (
            <Table
              data={filterReports(pdfList, coreData?.permissions)}
              categories={coreData?.categories}
              templates={pdfReports?.templates}
              setDeleteId={setDeleteId}
              setDeleteItem={setDeleteItem}
            loading={!fetched}
            />
        ) : shouldShowEmpty ? (
          <Empty type="PDF reports" />
        ) : null}
      </Center>
    </Container>
  );
};

export default List;

const fadeIn = keyframes`

    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Container = styled.div`
  margin-top: 40px;
  font-family: "Raleway";
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Center = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;

  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
`;

const Button = styled.div`
  color: white;
  background-color: #2D70E2;
  font-size: 14px;
  padding: 10px 20px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Raleway";
  border-radius:8px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: "Raleway";
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
